module.exports = __webpack_public_path__ + "img/18.e0a5ebd6.png";